export default "__VITE_ASSET__BcM2O_h2__"